import { CellContext } from "@tanstack/react-table";
import { memo, useCallback, useContext } from "react";
import classNames from "classnames";
import { UpdateTransactionDto } from "../../../common/dto/transactions/update-transaction.dto";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { CategorySelectPrompt } from "../CategorySelect/CategorySelectPrompt";
import { PaginatedTransactionsTableContext } from "../PaginatedTransactionsTableContextProvider";
import { TransactionCategoryChange } from "../TransactionCategoryChange";
import { BLOCK_EVENT_KEY } from "../../views/ViewTable";
import { ClickableContainer } from "../../general/ClickableContainer";
import {
    TransactionView,
    CategoryColumn,
} from "../../../common/types/views/transactionViews";
import { Taxonomy } from "../../../common/categories";
import { useIsDateLocked } from "../../../hooks/useIsDateLocked";
import styles from "./CategoryCell.module.scss";

export const CategoryCell = memo(
    ({ row, column, table }: CellContext<TransactionListItemDto, string>) => {
        const { saveTransaction } = useContext(
            PaginatedTransactionsTableContext,
        );
        const tableOptions: TransactionView["options"] = (
            table.options.meta as any
        ).options;
        const options: CategoryColumn["options"] = column.columnDef.meta ?? {};
        const isLocked = useIsDateLocked(
            row.original.entity.id,
            row.original.date,
        );

        const handleUpdate = useCallback(
            async (payload: UpdateTransactionDto) => {
                await saveTransaction(row.original, payload);
            },
            [saveTransaction, row.original],
        );

        const showRequired =
            options.required &&
            row.original.category?.taxonomy === Taxonomy.uncategorized;

        return (
            <div
                className={classNames(
                    styles.categoryCell,
                    showRequired && styles.required,
                )}
            >
                {tableOptions?.readonly || isLocked ? (
                    <CategorySelectPrompt transaction={row.original} readonly />
                ) : (
                    <ClickableContainer
                        as="span"
                        onClick={(e: any) => {
                            e.stopPropagation();
                            e[BLOCK_EVENT_KEY] = true;
                        }}
                    >
                        <TransactionCategoryChange
                            transaction={row.original}
                            onUpdate={handleUpdate}
                        />
                    </ClickableContainer>
                )}
            </div>
        );
    },
);
